import {connect} from 'react-redux';

import {getAvailableCategories} from '../../../../general/selectors';
import {getAvailableIndices} from '../../../selectors';

import Category from './Category';

const Body = ({indices, categories}) => {
    const filter = columns => indices.map(index => columns[index]);
    const colSpan = indices.length + 1;

    return categories.map(category => (
        <Category
            {...category}
            key={category.id}
            colSpan={colSpan}
            columnFilter={filter}
        />
    ));
};

const mapStateToProps = state => {
    const categories = getAvailableCategories(state);
    const indices = getAvailableIndices(state);

    return {
        indices,
        categories,
    };
};

export default connect(mapStateToProps)(Body);
